import { Modal, Skeleton } from 'antd'
import { flatten, map, orderBy } from 'lodash'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { ICommentDataField } from '../DetailSection/components/TaskTemplate/Fields/CommentField/components/CommentFieldDialog/CommentFieldDialog.interface'
import cx from 'classnames'
import { useAtom } from 'jotai'
import { themeAtom } from '@/jotai/theme.jotai'
import { isDark } from '@/utils/darkmode'
import './AllCommentDialog.style.less'
import HttpRequest from '@/config/axios.config'
import CommentDisplaySection from '../DetailSection/components/TaskTemplate/Fields/CommentField/components/CommentFieldDialog/components/CommentDisplaySection/CommentDisplaySection'

const queryKeys = {
  replyComment: 'replyComment',
  getComment: 'getComment',
}

const title = <div className="dialog-header py-2">All Comments</div>
const width = 800

interface Prop {
  visible: boolean
  onCancel: ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined
}

interface ICommentAll extends ICommentDataField {
  taskId?: string
  task?: any
}

export function AllCommentDialog(props: Prop) {
  const { visible, onCancel } = props
  const queryParams = new URLSearchParams(window.location.search)
  const orderKey = queryParams.get('orderKey')
  const [data, setdata] = useState([])
  const [theme] = useAtom(themeAtom)

  const {
    data: _comments,
    isLoading: _loadingComments,
    refetch,
  }: any = useQuery([queryKeys.getComment, visible], () => {
    return HttpRequest.get(`/comments/orders/${orderKey}`).then(
      (resp) => resp.data
    )
    // return { data: comment }
  })

  useEffect(() => {
    const _tempData = _comments?.data
      ? _comments?.data.map((item) => {
          return {
            ...item,
            comments: flatten(
              map(item?.tasks, (task) =>
                task?.comments
                  ? [
                      ...map(task?.comments, (comment) => {
                        return { ...comment, taskId: task?.id }
                      }),
                    ]
                  : []
              )
            ),
          }
        })
      : []
    setdata(_tempData)
  }, [_comments])

  return (
    <>
      {visible && (
        <Modal
          title={title}
          visible={visible}
          width={width}
          footer={null}
          onCancel={onCancel}
          className={cx(isDark(theme) && 'dark-comment')}
        >
          <div className="wrap-comments">
            <div className="row">
              <div className="col-12">
                {_loadingComments && <Skeleton active />}
                {data &&
                  data.map(
                    (item: {
                      name: string
                      display_order: number
                      comments: ICommentAll[]
                    }) => {
                      return (
                        <>
                          <div className="comment-section-name">
                            {item?.name}
                          </div>
                          {item.comments &&
                            orderBy(
                              item.comments,
                              ['created_date'],
                              ['desc']
                            ).map((comment: ICommentAll, index) => {
                              if (comment.type !== 'reply')
                                return (
                                  <div key={index}>
                                    <CommentDisplaySection
                                      onReload={refetch}
                                      section={'all'}
                                      data={comment}
                                      task={comment?.task}
                                      taskId={comment?.taskId}
                                    />
                                  </div>
                                )
                            })}
                        </>
                      )
                    }
                  )}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}
